import { CALLSIGNS } from './tasks.js';

/**
 * The crew's names, one to a seat.
 *
 * Chosen at the door rather than typed on a phone. The name cards are printed in advance with
 * a seat number and a name, and set out at their places before anyone arrives. At check-in a
 * guest picks a name on the steward's phone, which tells them where they sit; they scan that
 * seat's code and choose only a profession. So a name starts as a place at the table; since
 * 2026-10-24 a swap at the door exchanges two seats' names, so a guest moved keeps theirs
 * (`callsignAt`).
 *
 * The names are the show's own (tasks.ts), in seat order: seat 1 is VEGA. Every first letter
 * is different, so a guest can find their card from across the table at a glance.
 */
export function callsignForSeat(seat: number): string | null {
  return CALLSIGNS[seat - 1] ?? null;
}

/**
 * The call sign a seat carries tonight: its card, which a swap at the door may have exchanged with another seat's
 * (`ShowState.callsigns`, Marek, 2026-10-24: a guest moved keeps their name), else the seat's own from the list.
 * Every screen that names a seat, guest or not, reads it here.
 */
export function callsignAt(state: { callsigns?: Record<string, string> | undefined } | null | undefined, seat: number): string | null {
  return state?.callsigns?.[String(seat)] ?? callsignForSeat(seat);
}
